/**
 * JSON-LD <head> 注入工具（运行时，幂等）。
 *
 * 从 components/Seo.tsx 提取，供 Seo 组件和内容页（ArticleLayout 等）共用。
 * 每个 JSON-LD 块有唯一 id，重复注入会覆盖（幂等），切换路由时清理避免残留。
 */

const JSONLD_PREFIX = "jsonld-";

/** 幂等设置一个 JSON-LD 块（按 id 匹配，覆盖内容）。data 为对象，自动序列化。 */
export function upsertJsonLd(id: string, data: unknown): void {
  const fullId = `${JSONLD_PREFIX}${id}`;
  let el = document.getElementById(fullId) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = fullId;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/** 移除某 JSON-LD 块（路由离开该页面时清理）。 */
export function removeJsonLd(id: string): void {
  document.getElementById(`${JSONLD_PREFIX}${id}`)?.remove();
}
